export default "__VITE_ASSET__DAfsacOO__"